var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEtPrjAtivo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 24.5,
    r: 24.5,
    fill: "#212121"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.775 35.2C17.775 34.7582 18.1332 34.4 18.575 34.4H21.9249C22.3668 34.4 22.7249 34.7582 22.7249 35.2V35.2C22.7249 35.6418 22.3668 36 21.9249 36H18.575C18.1332 36 17.775 35.6418 17.775 35.2V35.2ZM16.95 32.8C16.95 32.3582 17.3082 32 17.75 32H22.7499C23.1918 32 23.5499 32.3582 23.5499 32.8V32.8C23.5499 33.2418 23.1918 33.6 22.7499 33.6H17.75C17.3082 33.6 16.95 33.2418 16.95 32.8V32.8ZM26.0981 14.3345C24.5477 12.829 22.4707 12 20.25 12C19.1658 11.9975 18.0919 12.2027 17.0898 12.6039C16.0877 13.005 15.1772 13.5942 14.4106 14.3376C13.644 15.0809 13.0364 15.9639 12.6227 16.9356C12.2091 17.9073 11.9974 18.9487 12 20C12 22.331 12.9214 24.5115 14.5266 25.982L14.7514 26.1865C15.68 27.0285 16.95 28.182 16.95 29.2V31.2H19.425V24.6555L17.9445 23.8414C17.5176 23.6066 17.3917 23.0516 17.6757 22.6557V22.6557C17.9105 22.3284 18.3496 22.2225 18.7078 22.4067L20.25 23.2L21.7727 22.3993C22.123 22.2151 22.555 22.31 22.7958 22.624V22.624C23.096 23.0154 22.9812 23.5818 22.5523 23.8254L21.075 24.6645V31.2H23.5499V29.2C23.5499 28.206 24.806 27.0535 25.7233 26.2115L25.9764 25.9785C27.6275 24.45 28.4999 22.3805 28.4999 20C28.5054 18.9486 28.2959 17.9066 27.8837 16.9342C27.4714 15.9618 26.8646 15.0782 26.0981 14.3345Z",
    fill: "#4D78AD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8257 33.8014C29.8257 34.0923 30.0615 34.3281 30.3524 34.3281H32.8476C33.1385 34.3281 33.3743 34.0923 33.3743 33.8014V29.5967H34.9652C35.4345 29.5967 35.6695 29.0294 35.3377 28.6976L31.9724 25.3324C31.7668 25.1267 31.4333 25.1267 31.2276 25.3324L27.8624 28.6976C27.5306 29.0294 27.7655 29.5967 28.2348 29.5967H29.8257V33.8014Z",
    fill: "#4D78AD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEtPrjAtivo);
export default __webpack_public_path__ + "static/media/IconEtPrjAtivo.a2c3c77f455d13cf00249f534814229d.svg";
export { ForwardRef as ReactComponent };